module.exports = __webpack_public_path__ + "img/icon_close.2fde435a.svg";